import { assertAllProductsOfSameCurrency } from "@/services/marketplace/order/purchases/purchasesValidators";
import { type Purchase } from "./purchasesTypes";
import { createNumericPrice, type PriceNumeric } from "@/services/prices";

export const countProductsPrice = (purchase: Purchase): PriceNumeric => {
  assertAllProductsOfSameCurrency(purchase);

  const currencyId = purchase.products[0].price.currencyId;
  const sum = createNumericPrice(0, currencyId);

  purchase.products.map(({ price }) => (sum.price += price.price));

  return sum;
};

export const hasSomePackages = (purchase: Purchase): boolean => purchase.shipping.parcels.length > 0;
